import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import { connect } from "formik";
import { compose } from "redux";
import _ from "lodash";

import { CAP_VOLS, MARKET_EXPECTATIONS_SHOCK, PARALLEL_SHOCK, STANDARD_DEVIATION_SHOCK } from "../../Constants/Constants";
import { shocks } from "../../Constants/DropDownLists";
import { StyledDecimalInput, StyledAutoCompleteInput, StyledLabel } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

function isMarketExpectationsSelected(shockType) {
  return !shockType || shockType === MARKET_EXPECTATIONS_SHOCK;
}

function shouldDisableShockValue(curve, shockType) {
  return (
    curve !== CAP_VOLS &&
    shockType === MARKET_EXPECTATIONS_SHOCK
  );
}

function getShockValueLabel(shockType) {
  if (shockType === PARALLEL_SHOCK) {
    return "Parallel Shift Amt (bp)";
  }
  if (shockType === STANDARD_DEVIATION_SHOCK) {
    return "Standard Deviations";
  }

  return "";
}

const RateEnvironmentSection = ({ formik }) => {
  const { values } = formik;
  const shouldHideFloatingRate = false;
  const shouldHideShockValue = isMarketExpectationsSelected(values.shockType);

  return (
    <>
      <Grid item xs={12} hidden={shouldHideFloatingRate}>
        <FormSectionTitle title="RATE ENVIRONMENT" />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} hidden={shouldHideFloatingRate}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Shock Scenario"}</StyledLabel>}
          fieldName="shockType"
          selectValue="value"
          options={shocks}
        />
      </Grid>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} hidden={shouldHideFloatingRate || shouldHideShockValue}>
        <StyledDecimalInput
          calculateLabel={({ values }) => getShockValueLabel(values.shockType)}
          fieldName="shockValue"
          disabled={shouldDisableShockValue(values.curve, values.shockType)}
        />
      </Grid>
    </>
  );
};
export default compose(
  connect
)(RateEnvironmentSection);
